import React, { useState } from "react";
import { Link } from "react-router-dom";
import desktopLogo from "../assests/images/desktopLogo.svg";
import hamburgerIcon from "../assests/images/hamburgerIcon.svg";
import cross from "../assests/images/cross.svg";
import useResponsiveFlags from "../hooks/useResponsiveFlags";

export default function NavbarGuest() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isMobile , isDesktop} = useResponsiveFlags();
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return (
    <nav className="navbar navbar-expand-lg navbar-expand-md" 
    style={{
            backgroundColor: "#031621",
            alignItems: "center",
            padding: "0",
          }}>
      <div style={{alignItems: "center", display:"flex", justifyContent:"space-between", width : "100%",flexWrap: isMobile ? "wrap" : "" }}>
        <Link className="navbar-brand" to="/">
          <img src={desktopLogo} alt="" style={{ padding: isMobile? "16px 20px": "20px", paddingLeft: isDesktop? "35px" : "20px"}} />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleMenu}
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
           <span><img
            src= {isMenuOpen ? cross:hamburgerIcon}
            alt=""
            style={{ marginRight: "1rem" }}
          /></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent" style={{textAlign:"center"}}>
          <ul className="navbar-nav ms-auto mb-0 mb-lg-0 text-white">
            <li className="nav-item-custom">
            <Link className="nav-link text-white" to="/contact">CONTACT</Link>
            </li>
            <li className="nav-item-custom">
            <Link className="nav-link text-white" to="/register">
              REGISTER
            </Link>
            </li>
            <li className="nav-item-custom" 
            style={{
              backgroundColor: "#0061BB",
              padding: isMobile ? "2rem" : "2rem 4rem",
              marginLeft: isMobile ? "0" : "1rem",
              textAlign: isMobile ? "center" : "",
            }}>
            <Link className="nav-link text-white" to="/login">
           LOG IN
           </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
